/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tabs/view.blocks to change it.
import More from './More/index'
import QuickAccess from './QuickAccess/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tabs({
  children,
  viewPath = "/App/Account/Topbar/Tabs"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Tabs.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<QuickAccess
  viewPath={`${viewPath}/QuickAccess`}
/>
<More
  viewPath={`${viewPath}/More`}
/>
</div>
{children}
</React.Fragment>)
}